module.exports = __webpack_public_path__ + "img/option_magento.628df3cb.svg";